import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import OrderController from '@/services/OrderController';

export const useDeliveryAssignment = ({ allShops, closeGenericOrderModal }) => {
	const [assignDeliveryModalOpen, setAssignDeliveryModalOpen] = useState(false);
	const [shopToAssignDelivery, setShopToAssignDelivery] = useState(null);
	const [orderToAssignDelivery, setOrderToAssignDelivery] = useState(null);
	const orderToAssignDeliveryRef = useRef();

	const selectShopForDelivery = order => {
		const { shopId } = order;
		setShopToAssignDelivery(allShops.find(it => it.id === shopId));
		setOrderToAssignDelivery(order);
		orderToAssignDeliveryRef.current = order;

		setAssignDeliveryModalOpen(true);
	};

	const openOrderDeliverySelectedModal = order => {
		const { shopId } = order;
		setShopToAssignDelivery(allShops.find(it => it.id === shopId));
		setOrderToAssignDelivery(order);
		orderToAssignDeliveryRef.current = order;

		setAssignDeliveryModalOpen(true);
	};

	const onDeliverySelect = async (deliveryId, toWoltDrive) => {
		try {
			const res = await OrderController.assignOrder(
				orderToAssignDelivery?.id || orderToAssignDelivery,
				deliveryId,
				toWoltDrive,
			);

			if (!res?.error) {
				toast.success('Επιτυχής ανάθεση');
				setAssignDeliveryModalOpen(false);
			} else {
				console.log(res?.error);
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
			}
		} catch (err) {
			toast.error(`Κάποιο πρόβλημα προέκυψε${err?.error || ''}`);
			console.log('onDeliverySelect err:', err);
		}
	};

	const onRemoveOrderDelivery = async orderId => {
		try {
			const isWoltDrive = orderToAssignDelivery?.deliveredBy === 'wolt';

			if (isWoltDrive) {
				const confirmed = window.confirm(`Σίγουρα θέλεις να αφαιρέσεις την WD;`);

				if (!confirmed) return;
			}
			const res = await OrderController.removeOrderDelivery(
				orderId || orderToAssignDelivery?.id || orderToAssignDelivery,
			);

			if (!res?.error) {
				toast.success(`Επιτυχής αφαίρεση ${isWoltDrive ? 'WD' : 'διανομέα'}`);
				setAssignDeliveryModalOpen(false);
				closeGenericOrderModal?.();
			} else {
				console.log(res?.error);
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
			}
		} catch (err) {
			toast.error(`Κάποιο πρόβλημα προέκυψε${err?.error || ''}`);
			console.log('onRemoveOrderDelivery err:', err);
		}
	};

	return {
		assignDeliveryModalOpen,
		setAssignDeliveryModalOpen,
		shopToAssignDelivery,
		orderToAssignDelivery,
		setOrderToAssignDelivery,
		orderToAssignDeliveryRef,
		selectShopForDelivery,
		openOrderDeliverySelectedModal,
		onDeliverySelect,
		onRemoveOrderDelivery,
	};
};
